import React, { useState,useEffect } from 'react';
import { callIcon } from '../../../Images/Images';
import { LabelInput, AgentButton}  from 'global-components-library';
import { Singleton } from '../../../js/Singleton';
import {  USER_STATE } from '../../../constants';
import { UncontrolledTooltip } from 'reactstrap';
import { useSelector } from 'react-redux';

const language = new Singleton();

const ContainerDataPreview = ({updateDataCallPreview,userState,data,headers,callKey,showLog,setShowLog,showOnlyData=false,showDataLogDisp=false,onChangeData,disableInput}) => {
    const [listData,setListData]=useState([]);
    const [listaHeaders,setListaHeaders]=useState([]);
    const [showData, setShowData] = useState(false);
    const [original,setOriginal] = useState([{}]);
    const [disabledUpdate,setDisabledUpdate] = useState(true);
    const showContainer = useSelector(state => state.previewActions.showData);
    const recordPreview = useSelector(state => state.preview);
    const [dataObj,setDataObj]=useState([]);
    const [width, setWidth] = useState('colN2');
    const {simultaneosRecs} = useSelector(state=>state.preview);
    const [tempWidth, setTempWidth] = useState('');
    const [labelDataClientTitle,setLabelDataClientTitle] = useState()
    const [tempArrayToSave,setTempArrayToSave] = useState(data);

    useEffect(() => {
      if(userState === USER_STATE.AGENT_PREVIEW || userState === '')
      {
        setLabelDataClientTitle(language.getText("CallControlGUIContactDatatitlePreview"))
      }else{
        setLabelDataClientTitle(language.getText("CallControlGUIContactDatatitle"))
      }
    }, [userState])
    
    useEffect(() => {
      onChangeData && onChangeData({newArray:tempArrayToSave,disabledUpdate: disabledUpdate})
    }, [disabledUpdate,tempArrayToSave])
    
    useEffect(() => {
      setOriginalObj();
      fnDisableUpdate();
    },[tempArrayToSave])

    useEffect(() => {
      fnDisableUpdate();
    }, [data])
    

    useEffect(() => {
      if(data.length > 0 && headers.length > 0)
      {
        setListData(data);
        setListaHeaders(headers);
        setTempArrayToSave(data);
      }
      
    }, [data])


    useEffect(() => {
        if(listData.length>0)
        {
          if(userState !== USER_STATE.DIALOG)
          {
            setColumns();
            setOriginalObj();
            setShowData(true);
          }
          else{
            setColumns();
            setOriginalObj();
            setShowData(true);
          }
        }
      }, [listData])

      useEffect(() => {
        if(showLog){
          setWidth('colN1_SimultaneousView')
        } else{
          setWidth(tempWidth)
        }
      }, [showLog])
      
      const setOriginalObj = () => {
        let originalObj = tempArrayToSave.map(function(dato, i) {
          return {indice:i+1,dato:dato};
        });
        setOriginal(originalObj)
      }
      
      const setColumns = ()=> {
        let c = data.map(function(dato, i) {
          return {dato:dato, header:listaHeaders[i], indice:i+1};
        });
        setDataObj(c);
        defineNumberColumns();
      }

      const defineNumberColumns =()=>{
        let nData= data.length;
        if(simultaneosRecs)
        {
          widthForSimultaneousView(nData);
        }
        else if(userState === USER_STATE.AGENT_PREVIEW || userState === USER_STATE.WRAPUP){    
          widthForMax3columns(nData);
        }
        else if(userState === USER_STATE.DIALOG){
          widthForMax4Columns(nData)
        }
      }

      const widthForMax3columns = (nData) => {
        if(nData>=9 & nData<=15){
          setWidth('colN3_max3Col');
        }else if(nData>1 & nData<9){
          setWidth('colN2_max3Col')
        }else{
          setWidth('colN1_max3Col')
        }
      }
      const widthForMax4Columns = (nData) => {
        if(nData === 1){
          setWidth('colN1_max4Col')
        }else if(nData <=8){
          setWidth('colN2_max4Col')
        } else if(nData >=9 & nData <= 11){
          setWidth('colN3_max4Col')
        } else{
          setWidth('colN4_max4Col')
        }
      }
      const widthForSimultaneousView = (nData) => {
        if (nData <= 5){
          setWidth('colN1_SimultaneousView-fiveOrLess');
          setTempWidth('colN1_SimultaneousView-fiveOrLess');
        }else{
          setWidth('colN2_SimultaneousView');
          setTempWidth('colN2_SimultaneousView');
        }
      }
      const saveData = (dato,i) => {
          let tempObj ={indice:i,dato:dato};
          let newArray = original.map(o => o.indice === tempObj.indice ? tempObj.dato : o.dato);
          setTempArrayToSave(newArray);      
        }

      const sendData = () => {
        setDisabledUpdate(true);
        let temp = [...tempArrayToSave]
        while (temp.length < 15) {
          temp.push('');
        }
        
        let dataPrev = {
          callKey: recordPreview.callKey,
          camID: recordPreview.camId,
          newData: temp,
          callOutId: recordPreview.callOutId
        }
        updateDataCallPreview(dataPrev);
      }
      const fnDisableUpdate = () => {
        let somethingChange = JSON.stringify(data) !== JSON.stringify(tempArrayToSave);
        let isEqual = somethingChange === disabledUpdate;
        somethingChange ? (isEqual && setDisabledUpdate(false) ) : (isEqual && setDisabledUpdate(true) );
      }

    return (
      <div className={`cdp-infoContainer ${(userState=== USER_STATE.WRAPUP && !simultaneosRecs) ? '_wrapup':''}  ${simultaneosRecs?'simultaneousView':''} ${showLog ? 'showLog':''} ${showDataLogDisp === true ? 'showDataLogDisp':''} ${showOnlyData === true? 'showOnlyData':''} `}>
        <div className={`cdp-recordInformation ${showLog ? 'showLog' :''}`}>
          <div className={`dataClientTitle ${simultaneosRecs && 'simultaneousView'}`}>
            {labelDataClientTitle}
              <div className={`callKeyPreview ${simultaneosRecs ? 'simultaneosRecs' : ''}`}>
                <img className="callKeyIcon" src={callIcon} alt="icon"></img>
                <div className='callKeyValuePreview'>{callKey}</div>
              </div>
          </div>
          { (simultaneosRecs && !showLog) &&
              <div className='cdp-container-log' >
                <i className='gcl-icon history' id='cdp-btn-LogRec' onClick={() =>  setShowLog(!showLog)}/>
                <UncontrolledTooltip innerClassName='dal-tooltip-log' placement='top' target='cdp-btn-LogRec' boundariesElement='window'>{language.getText('GUIPreviewdialingLogBtn')}</UncontrolledTooltip>
              </div>
          }
        </div>
        
        <div className={`DataPreviewContainer ${simultaneosRecs?'simultaneousView':''} ${showLog?'showLog':''}`}> 
        {(showData && dataObj.length>0) && <div className={`colN1 ${width} ${showLog ? 'showLog' :''}`}>
            {
              
                dataObj.map((dato,index) => (                  
                  <div className={`alignLabelInput ${width}`}>
                    <LabelInput
                    key={dato.indice}
                    label={dato.header} 
                    focus placeholder={dato.header} 
                    value={dato.dato}
                    disabled={disableInput}  
                    onChange={e =>saveData(e,dato.indice)} 
                    multiline={true} 
                    rows={2}
                    maxRows={2}
                    numberInput={dato.indice} 
                    withNumber={true}
                    maxLength={255}
                    /> 
                </div>))
            }  
        </div>}   
      </div>

      {(userState === USER_STATE.DIALOG && recordPreview.simultaneosRecs === false) && <div className='containerCenterButton'><AgentButton type='primary' disabled={disabledUpdate} onClick={sendData}>{language.getText("CallControlGUIContactDatabuttom")}</AgentButton></div> }
      {(userState === USER_STATE.OTHER && showContainer && recordPreview.simultaneosRecs === false) && <div className='containerCenterButton'><AgentButton type='primary' disabled={disabledUpdate} onClick={sendData}>{language.getText("CallControlGUIContactDatabuttom")}</AgentButton></div> }
      
      </div>
    )
}

export default ContainerDataPreview;




// WEBPACK FOOTER //
// ./src/components/workSpace/Others/ContainerDataPreview.jsx